import React, { memo } from 'react';
import { BlurView } from 'expo-blur';
import { MB_BlurProps } from './MB_BlurUtils';

const MB_Blur = memo(({ intensity, ...props }: MB_BlurProps) => {
  return <BlurView intensity={intensity ?? 20} {...props} />;
});

export { MB_Blur };
